module.exports = "/* google charts anti-flickering */\r\nsvg > g:last-child > g:last-child { pointer-events: none }\r\ndiv.google-visualization-tooltip { pointer-events: none }"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ui/home-timechart/home-timechart.component.css
// module id = ./src/app/components/ui/home-timechart/home-timechart.component.css
// module chunks = main